import { StartPosition } from './types';

export const POSITIONS_TO_DEG: Record<StartPosition, number> = {
  right: 0,
  top: -90,
  left: -180,
  bottom: -270,
};
